var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item[_vm.header.value])?_c('v-btn',{staticClass:"text-capitalize",attrs:{"text":"","href":`${ _vm.isAppLink ? _vm.appUrl : '' }/${ _vm.header.path ? _vm.header.path : ''}${ _vm.item[_vm.header.value] }`,"target":"_blank","light":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.header.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }